<template>
  <div id="Review">
    <div style="padding: 0 0.5rem 0.5rem">
      <b-button variant="primary"  @click="save()"
        ><b-icon icon="check" />&nbsp;{{ $t("message.Save_cmd") }}</b-button
      >&nbsp;&nbsp;
      <b-button  @click="hideModal()"
        ><b-icon icon="x" />&nbsp;{{ $t("message.Close_cmd") }}</b-button
      >
    </div>
    <div
      class="well"
      style="   margin-bottom: 0;        position: relative;
        overflow: auto;
                max-height: 29rem;

        width: 100%;        border-bottom: 1px solid #111;
        border-top: 1px solid #111;
      "
    >
      <table
        style="border: 2.5px solid; padding: 5px; width: 100%"
        rules="all"
        cellpadding="5"
        v-if="_props != null"
      >
        <tbody style="line-height: 1.5rem">
          <tr style="height: 3.5em">
            <td class="ncut-edit-form-text label-td" style="width: 7.5rem">
              申請案件編號：
            </td>
            <td class="ncut-base-form-ipt text-td" style="min-width: 7rem">
              {{ _props.id }}
            </td>
            <td class="ncut-edit-form-text label-td" style="width: 7rem">

            </td>
            <td class="ncut-base-form-ipt text-td" style="min-width: 10rem">

            </td>
          </tr>
          <tr style="height: 3.5em">
            <td class="ncut-edit-form-text label-td" style="min-width: 7rem">
              審核結果:
            </td>
            <td class="ncut-edit-form-text label-td" style="width: 7.5rem">
              <b-form-select
                class="form-control"
                id="IsCompleteSelectText"
                v-model="selected2"
                ref="selected2"
                @change="UpdateIsComplete()"
                :options="options2"
              >
              </b-form-select>
            </td>

            <td v-if="queryInfo.IsComplete ==1" class="ncut-edit-form-text label-td" style="width: 7rem">
              建議獎勵金：

              <input
                type="text"
                onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                onpaste="return false"
                maxlength="5"
                v-model="queryInfo.Money"
              />
            </td>
            <td v-else>&nbsp;</td>
            <td>原因(如符合、不符合、資料錯誤):
              <input type="text" maxlength="40" v-model="queryInfo.Reason" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as tools from "@/tool";

export default {
  name: "Review",
  props: ["id", "sid"],
  data() {
    return {
      name: null,
      isIE: false,
      inputData: null,
      memo: "無",
      queryInfo: {

        ID: this.$props.id,
        Sid: this.$props.sid,
        UpdateUser: null,
        IsComplete: null,
        Money: 0,
        Reason: null,
      },
      selected2: null,
      options2: [
        { value: "1", text: "符合" },
        { value: "2", text: "不符合" },
        { value: "3", text: "資料錯誤" },
      ],
    };
  },
  computed: {
    sysId() {
      return this.$store.getters.getSysId;
    },
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    UpdateIsComplete() {

      this.queryInfo.IsComplete = this.selected2;
      if(this.selected2 == 2 || this.selected2 == 3)
      this.queryInfo.Money=0;
      else
      this.queryInfo.Reason="符合";

    },
    hideModal() {
      this.$emit("hideModal");
    },
    close() {
      this.$emit("hideModal");
    },
    checkSaveData() {
      let msg = "";

      if (tools.isNullOrEmpty(this.queryInfo.IsComplete)) {
        msg = "審核結果";
      } else if (this.selected2 == 1 && this.queryInfo.Money ==0 ) {

        msg = "獎勵金";
      } else if (tools.isNullOrEmpty(this.queryInfo.Reason)) {
        msg = "原因";
      }
      return msg;
    },
    save() {




      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;

        this.queryInfo.UpdateUser= this.user.id;
        this.$http
          .put("./WebApi/SportsExcellent/ReviewApply/", this.queryInfo)
          .then((response) => {
            if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,審核成功");

          } else {
            tools.showAlert(vm, "danger", "對不起,審核失敗");
          }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(
          this,
          "danger",
          "對不起,請輸入".concat(msg).concat("!")
        );
      }
    },


  },
  created() {
    console.log("======created EditReview =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    // this.queryInfo.UpdateUser=this.$store.getters.getUser.id;
    //this.name=this.$store.getters.getUser.name;
   //  console.log('this.$props.id',this.$props.id);
   //  console.log('this.$props.sid',this.$props.sid);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
